export default "__VITE_ASSET__CH9HvI8b__"